import { createApi } from '@reduxjs/toolkit/query/react';
import { createBackendBaseQuery, transformApiError, withCountryHeader } from '../../../utils/createAuthBaseQuery';
import { API_URLS } from '../../../constants/apiUrl';

// Mirrors the backend ElektronikonSolutionSearchResultDto.
export interface ElektronikonSolutionResponse {
  oldControllerPartNumber?: number;
}

// Mirrors the backend SearchElektronikonSolutionRequest. Property names bind
// case-insensitively to the request object (e.g. serialNumber -> SerialNumber).
export interface FetchElektronikonSolutionParams {
  controllerPartNumber?: number;
  serialNumber?: string;
  elektronikonSolutionLogId?: number;
}

const BASE_URL = process.env.REACT_APP_MOTER_SERVICE_API_BASE_URL as string;

if (!BASE_URL) {
  throw new Error('REACT_APP_MOTER_SERVICE_API_BASE_URL environment variable is not set');
}

const baseQuery = createBackendBaseQuery(BASE_URL);

// Attach the user's country header to the Elektronikon Solution/Search request.
const baseQueryWithCountry = withCountryHeader(
  baseQuery,
  (url) => url.includes(API_URLS.ELEKTRONIKON.SOLUTION_SEARCH),
  'elektronikonSolutionApi'
);

export const elektronikonSolutionApiSlice = createApi({
  reducerPath: 'elektronikonSolutionApi',
  baseQuery: baseQueryWithCountry,
  tagTypes: ['ElektronikonSolution'],
  endpoints(builders) {
    return {
      fetchElektronikonSolution: builders.query<
        ElektronikonSolutionResponse,
        FetchElektronikonSolutionParams
      >({
        query: (params) => {
          let queryString = '';
          if (params) {
            const usp = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== '') {
                usp.append(key, String(value));
              }
            });
            queryString = usp.toString() ? `?${usp.toString()}` : '';
          }
          return {
            url: `${API_URLS.ELEKTRONIKON.SOLUTION_SEARCH}${queryString}`,
            method: 'GET',
          };
        },
        providesTags: ['ElektronikonSolution'],
        transformErrorResponse: transformApiError,
      }),
    };
  },
});

export const { useFetchElektronikonSolutionQuery, useLazyFetchElektronikonSolutionQuery } =
  elektronikonSolutionApiSlice;
